import { Input, InputIconButton, InputProps } from './Input';
import { useControllableState } from '@chakra-ui/react';


import * as React from 'react';
import { Eye, EyeCross } from 'core/img';
import { FieldValues, Path } from 'react-hook-form';


export interface PasswordVisibilityProps {
	defaultVisible?: boolean
	visible?: boolean
	onVisibleChange?: (visible: boolean) => void
}

// De momento expongo como ref tal cual un HtmlInputElement, si queremos caparlo el día mañana podemos hacer lo que hacemos con el form
export type PasswordInputRef = HTMLInputElement;

export interface PasswordInputProps<T extends FieldValues, TPath extends Path<T>> extends Omit<InputProps<T, TPath>, 'endElement' | 'type'>, PasswordVisibilityProps {
}

export const PasswordInput = <T extends FieldValues, TPath extends Path<T>>(props: PasswordInputProps<T, TPath>) => {
	const {
		defaultVisible,
		visible: visibleProp,
		onVisibleChange,
		...rest
	} = props;

	const [visible, setVisible] = useControllableState({
		value: visibleProp,
		defaultValue: defaultVisible || false,
		onChange: onVisibleChange,
	});

	const inputRef = React.useRef<HTMLInputElement>(null);

	return (
		<Input {...rest} type={visible ? 'text' : 'password'}
			ref={inputRef}
			endElement={
				<InputIconButton
					disabled={rest.disabled}
					onPointerDown={(e) => {
						if (rest.disabled) return;
						if (e.button !== 0) return;
						e.preventDefault();
						inputRef.current?.querySelector('input')?.classList.add('selected');
						setVisible(!visible);
					}}
					icon={visible ? Eye : EyeCross}
					w='5'
					h='5'
				/>
			}
		/>
	);
};

